<template>
  <class-detail-section class="teacher-section-info" title="Teaching Offerings">
    <template #actions>
      <button
        v-if="teacherProfile.can_edit"
        class="teacher-section-info__edit-button"
        @click="editOfferings"
        data-test-id="edit-teaching-offerings-button"
      >
        <span class="teacher-section-info__edit-icon">
          <font-awesome-icon :icon="['fas', 'edit']" />
        </span>
      </button>
    </template>

    <template v-if="offerings.length">
      <div
        class="teacher-section-info__data-item"
        v-for="offering in offerings"
        :key="offering.code"
        data-test-id="teaching-offering"
      >
        <span class="teacher-section-info__label">{{ offering.label }}</span>
        <div class="teacher-section-info__value" :data-test-id="`teaching-offering-${offering.code}`">
          {{ offeredLabel(offering.offered) }}
        </div>
      </div>
    </template>
    <div v-else class="teacher-section-info__value" data-test-id="teaching-offerings-unknown">
      {{ offeredLabel(null) }}
    </div>
  </class-detail-section>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ClassDetailSection from '@/views/classes/components/ClassDetailSection';
import ModalTeacherTeachingOfferings from './forms/ModalTeacherTeachingOfferings';
import constants from './forms/constants';

const OFFERED = 'Yes';
const NOT_OFFERED = 'No';
// The same dash the Coaching Plan column on the teachers list shows for a designation webackend did not
// report: an unknown answer is not a "No".
const UNKNOWN = '-';

export default {
  name: 'TeacherTeachingOfferings',

  components: {
    ClassDetailSection,
    FontAwesomeIcon,
  },

  props: {
    // The whole profile, as the sibling boxes take it: the editing path needs can_edit, and modalConfig
    // hands the profile to the modal.
    teacherProfile: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // One row per offering the backend reports. The box is always rendered, so that a teacher who offers
    // nothing reads as an answer instead of as a missing section.
    offerings() {
      return this.teacherProfile.teaching_offerings || [];
    },
  },

  methods: {
    editOfferings() {
      this.$modal.show(ModalTeacherTeachingOfferings, ...constants.modalConfig(this));
    },

    offeredLabel(offered) {
      if (offered === true) {
        return OFFERED;
      }
      if (offered === false) {
        return NOT_OFFERED;
      }
      return UNKNOWN;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';
@import '~styles/components/teacher-management-sections';
</style>
